import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatDate = (d) =>
  new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

export default function Insights() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/insights`)
      .then((r) => setPosts(r.data))
      .catch(() => {});
  }, []);

  if (!posts.length) return null;

  return (
    <section id="insights" data-testid="insights-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 md:py-32">
      <SectionHead
        overline="Insights Journal"
        title={<>Ideas that shape <em className="gold-text not-italic">mandates.</em></>}
        testId="insights-heading"
      />
      <div className="grid gap-4 md:grid-cols-3">
        {posts.map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.08} className="h-full">
            <a
              href={`/insights/${p.slug}`}
              data-testid={`insight-card-${p.slug}`}
              className="group flex h-full flex-col justify-between border border-[rgba(212,175,55,0.18)] bg-[#0F1A2E]/70 p-7 transition-colors duration-500 hover:border-[#D4AF37]/55 hover:bg-[#16243E] sm:p-8"
            >
              <div>
                <div className="flex items-center justify-between font-mono-alt text-[10px] uppercase tracking-[0.22em] text-[#64748B]">
                  <span>{formatDate(p.date)}</span>
                  <span>{p.read_time}</span>
                </div>
                <h3 className="mt-5 font-serif text-xl leading-snug text-[#F7F5F0] transition-colors duration-300 group-hover:text-[#E5C158] sm:text-2xl">
                  {p.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-[#94A3B8]">{p.excerpt}</p>
              </div>
              <div className="mt-8 flex items-center justify-between border-t border-[rgba(212,175,55,0.15)] pt-5">
                <span className="font-mono-alt text-[10px] uppercase tracking-[0.22em] text-[#94A3B8]">
                  {p.author}
                </span>
                <span className="flex items-center gap-2 font-mono-alt text-[10px] uppercase tracking-[0.22em] text-[#D4AF37]">
                  Read
                  <ArrowUpRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
